import { useQuery } from 'react-query';

import { getViewerCurrency } from '../internationalization/utils/get-viewer-currency';

import { getMastersPrice } from './controllers/get-masters-price';

export function useMastersPrice(currency = getViewerCurrency()) {
  return useQuery(
    ['mastersPrice', currency],
    () => {
      return getMastersPrice(currency);
    },
    {
      enabled: Boolean(currency),
    }
  );
}
